import React, { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/src/components/ui/button.tsx";

const NowAvailable = () => {
    const [currentSlide, setCurrentSlide] = useState(0);

    const availableItems = [
        {
            id: 1,
            title: "Side Order",
            artist: "Sim Fossil",
            description: "Available now on 12\" single & Digital",
            image: "//www.dreamchimney.com/releases/DC025/DC025-Desktop-Vinyl.jpg",
            link: "https://dreamchimney.bandcamp.com/album/side-order"
        },
        {
            id: 2,
            title: "Liminal City '87",
            artist: "Personal System 個人システム",
            description: "Available now on limited Cassette, CD & Digital",
            image: "//www.dreamchimney.com/releases/DC024/DC024-Desktop.jpg",
            link: "https://dreamchimney.bandcamp.com/album/liminal-city-87-live-in-tokyo"
        },
        {
            id: 3,
            title: "Soft Motion",
            artist: "Ray Cheser",
            description: "Available now on limited Cassette & Digital",
            image: "//www.dreamchimney.com/releases/DC023/dc023-feature-tile.jpg",
            link: "https://dreamchimney.bandcamp.com/album/soft-motion"
        },
        {
            id: 4,
            title: "Tidal Figures",
            artist: "Sim Fossil",
            description: "Available now on Digital & LP via Bandcamp.",
            image: "//www.dreamchimney.com/releases/DC022/dc022-feature-tile.jpg",
            link: "https://dreamchimney.bandcamp.com/album/tidal-figures"
        },
        {
            id: 5,
            title: "Sunlight Hits",
            artist: "Sorcerer",
            description: "Available now on Cassette, CD & Digital via Bandcamp.",
            image: "//www.dreamchimney.com/releases/DC021/dc021-feature-tile.jpg",
            link: "https://dreamchimney.bandcamp.com/album/sunlight-hits"
        },
        {
            id: 6,
            title: "Routine Gives Me the Space to Dream",
            artist: "Sparkling Water",
            description: "Available now on Cassette & Digital via Bandcamp.",
            image: "//www.dreamchimney.com/releases/DC020/dc020-feature-tile.jpg",
            link: "https://dreamchimney.bandcamp.com/album/routine-gives-me-the-space-to-dream"
        },
        {
            id: 7,
            title: "Jetty Summer",
            artist: "Perth Lewis",
            description: "New 12 track album from Perth Lewis. Available on CD / Cassette / Digital",
            image: "//www.dreamchimney.com//releases/DC019/DC019-tape-plants-email.jpg",
            link: "https://dreamchimney.bandcamp.com/album/jetty-summer"
        }
    ];

    const nextSlide = () => {
        setCurrentSlide((prev) => (prev + 1) % availableItems.length);
    };

    const prevSlide = () => {
        setCurrentSlide((prev) => (prev - 1 + availableItems.length) % availableItems.length);
    };

    const handleBuyNow = (link) => {
        window.open(link, '_blank');
    };

    return (
        <div className="relative">
            <div className="overflow-hidden">
                <div
                    className="flex transition-transform duration-300 ease-in-out"
                    style={{ transform: `translateX(-${currentSlide * 100}%)` }}
                >
                    {availableItems.map((item) => (
                        <div key={item.id} className="w-full flex-shrink-0">
                            <div className="block">
                                <a href={item.link} target="_blank">
                                    <img
                                        src={item.image}
                                        alt={`${item.artist} - ${item.title}`}
                                        className="w-full h-auto object-cover rounded-lg"
                                    />
                                </a>
                                <p className="text-base text-center pt-4 pb-4">
                                    <strong>{item.artist} "{item.title}"</strong><br />
                                    {item.description}
                                </p>
                                <Button
                                    size="sm"
                                    className="w-full bg-white hover:bg-gray-100 text-black font-semibold py-2 px-4 rounded text-xs border border-gray-300"
                                    onClick={() => handleBuyNow(item.link)}
                                >
                                    Buy Now
                                </Button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <Button
                variant="ghost"
                size="icon"
                className="absolute left-0 top-1/2 -translate-y-1/2 z-20 bg-black/50 hover:bg-black/70 text-white"
                onClick={prevSlide}
            >
                <ChevronLeft className="h-6 w-6" />
            </Button>

            <Button
                variant="ghost"
                size="icon"
                className="absolute right-0 top-1/2 -translate-y-1/2 z-20 bg-black/50 hover:bg-black/70 text-white"
                onClick={nextSlide}
            >
                <ChevronRight className="h-6 w-6" />
            </Button>
        </div>
    );
};

export default NowAvailable; 